import { apiClient } from '@/shared/lib/api-client';
import type { MyClubsResponse } from '@bookclub/shared';

export async function fetchMyClubs(): Promise<MyClubsResponse> {
  return apiClient.get('my-clubs').json<MyClubsResponse>();
}
